import React, { use, useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';
import UseSale from 'hooks/UseSale';
import { useSelector } from 'react-redux';

const EmployeeProfileModal = ({ isOpen, onClose, employee }) => {
  const [activeTab, setActiveTab] = useState('overview');
  // console.log(employee);
  
 const {sale} = useSelector((state)=>state.sale)
//  console.log(sale)
 let [sales,setSales] = useState([])
  
 let filter = sale?.filter((a,b)=>{
  return a?.employeeId?._id == employee?._id
 })
 useEffect(()=>{
  setSales(filter)
 },[sale,employee])

  if (!isOpen || !employee) return null;

  const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-SG', {
    style: 'currency',
    currency: 'SGD'
  }).format(amount);
};

// useEffect(()=>{
//   if(employee){
//     // let filteredSale = sale?.filter((a,b)=>)
//   }
// },[employee])


  const formatDate = (date) => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(new Date(date));
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      active: { color: 'text-success bg-success/10', label: 'Active' },
      inactive: { color: 'text-warning bg-warning/10', label: 'Inactive' },
      suspended: { color: 'text-destructive bg-destructive/10', label: 'Suspended' }
    };
    
    const config = statusConfig[status] || statusConfig.active;
    
    return (
      <span className={`px-3 py-1 rounded-full text-sm font-medium ${config.color}`}>
        {config.label}
      </span>
    );
  };

  const getRoleBadge = (role) => {
    const roleConfig = {
      manager: { color: 'text-primary bg-primary/10', label: 'Manager' },
      supervisor: { color: 'text-secondary bg-secondary/10', label: 'Supervisor' },
      employee: { color: 'text-muted-foreground bg-muted', label: 'Employee' },
      intern: { color: 'text-accent bg-accent/10', label: 'Intern' }
    };
    
    const config = roleConfig[role] || roleConfig.employee;
    
    return (
      <span className={`px-3 py-1 rounded-full text-sm font-medium ${config.color}`}>
        {config.label}
      </span>
    );
    
  };

  // Mock billing history data
  const billingHistory = [
    {
      id: 1,
      date: new Date('2025-01-28'),
      product: 'Premium Software License',
      amount: 299.99,
      status: 'completed',
      invoiceId: 'INV-2025-001'
    },
    {
      id: 2,
      date: new Date('2025-01-25'),
      product: 'Cloud Storage Upgrade',
      amount: 49.99,
      status: 'completed',
      invoiceId: 'INV-2025-002'
    },
    {
      id: 3,
      date: new Date('2025-01-22'),
      product: 'Training Materials',
      amount: 149.99,
      status: 'pending',
      invoiceId: 'INV-2025-003'
    }
  ];

  // Mock activity logs
  const activityLogs = [
    {
      id: 1,
      action: 'Login',
      timestamp: new Date('2025-01-30T09:15:00'),
      details: 'Logged in from Chrome on Windows',
      type: 'auth'
    },
    {
      id: 2,
      action: 'Bill Created',
      timestamp: new Date('2025-01-30T10:30:00'),
      details: 'Created bill for Premium Software License - $299.99',
      type: 'billing'
    },
    {
      id: 3,
      action: 'Profile Updated',
      timestamp: new Date('2025-01-29T14:45:00'),
      details: 'Updated contact information',
      type: 'profile'
    },
    {
      id: 4,
      action: 'Password Reset',
      timestamp: new Date('2025-01-28T16:20:00'),
      details: 'Password reset via WhatsApp OTP',
      type: 'security'
    }
  ];

  const tabs = [
    { id: 'overview', label: 'Overview', icon: 'User' },
    { id: 'billing', label: 'Billing History', icon: 'Receipt' },
    // { id: 'activity', label: 'Activity Log', icon: 'Activity' },
    // { id: 'permissions', label: 'Permissions', icon: 'Shield' }
  ];

  const renderOverview = () => (
    <div className="space-y-6">
      {/* Personal Information */}
      <div className="bg-muted/30 rounded-lg p-6">
        <h4 className="text-sm font-medium text-foreground mb-4">Personal Information</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="text-xs text-muted-foreground">Full Name</label>
            <p className="text-sm font-medium text-foreground">{employee.name}</p>
          </div>
          <div>
            <label className="text-xs text-muted-foreground">Employee ID</label>
            <p className="text-sm font-medium text-foreground">{employee?._id}</p>
          </div>
          <div>
            <label className="text-xs text-muted-foreground">Email Address</label>
            <p className="text-sm font-medium text-foreground">{employee.email}</p>
          </div>
          <div>
            <label className="text-xs text-muted-foreground">Phone Number</label>
            <p className="text-sm font-medium text-foreground">{employee?.mobile}</p>
          </div>
          {/* <div>
            <label className="text-xs text-muted-foreground">Department</label>
            <p className="text-sm font-medium text-foreground capitalize">{employee.department || 'Sales'}</p>
          </div> */}
          {/* <div>
            <label className="text-xs text-muted-foreground">Join Date</label>
            <p className="text-sm font-medium text-foreground">{formatDate(employee.createdAt || new Date())}</p>
          </div> */}
        </div>
      </div>

      {/* Billing Summary */}
      <div className="bg-muted/30 rounded-lg p-6">
        <h4 className="text-sm font-medium text-foreground mb-4">Billing Summary</h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="text-center p-4 bg-card rounded-lg border border-border">
            <div className="text-2xl font-bold text-primary">{formatCurrency(employee.LastMonthSale)}</div>
            <div className="text-xs text-muted-foreground">Billing Sales</div>
          </div>
          {/* <div className="text-center p-4 bg-card rounded-lg border border-border">
            <div className="text-2xl font-bold text-success">{formatCurrency(employee.billingUsed)}</div>
            <div className="text-xs text-muted-foreground">Amount Used</div>
          </div>
          <div className="text-center p-4 bg-card rounded-lg border border-border">
            <div className="text-2xl font-bold text-accent">{formatCurrency(employee.billingLimit - employee.billingUsed)}</div>
            <div className="text-xs text-muted-foreground">Remaining</div>
          </div> */}
        </div>
      </div>
    </div>
  );

  const renderBillingHistory = () => (
    <div className="space-y-4">
     {sales.length > 0 ? (
        sales.map((bill) => (
          <div key={bill?._id} className="bg-muted/30 rounded-lg p-4 border border-border">
            <div className="flex items-center justify-between mb-2">
              <div>
                <h5 className="text-sm font-medium text-foreground">
                  {bill?.services?.map((srv) => srv?.name).join(', ')}
                </h5>
                <p className="text-xs text-muted-foreground">Customer: {bill?.customerName}</p>
                <p className="text-xs text-muted-foreground">Mobile: {bill?.mobileNumber}</p>
              </div>
              <div className="text-right">
                <div className="text-sm font-bold text-foreground">
                  {formatCurrency(bill?.amount)}
                </div>
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${bill?.paymentMethod === 'cash' ? 'text-success bg-success/10' : 'text-primary bg-primary/10'}`}>
                 {bill?.paymentMethod === 'cash' ? 'Cash' : 'Online'}
                </span>
              </div>
            </div>
            <div className="text-xs text-muted-foreground">
              {formatDate(bill?.createdAt)}
            </div>
          </div>
        ))
      ) : (
        <p className="text-sm text-muted-foreground">No sales found for this employee.</p>
      )}
    </div>
  );

  // const renderActivityLog = () => (
  //   <div className="space-y-4">
  //     {activityLogs.map((log) => (
  //       <div key={log.id} className="flex items-start space-x-3 p-4 bg-muted/30 rounded-lg border border-border">
  //         <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
  //           log.type === 'auth' ? 'bg-primary/10 text-primary' :
  //           log.type === 'billing' ? 'bg-success/10 text-success' :
  //           log.type === 'profile'? 'bg-accent/10 text-accent' : 'bg-destructive/10 text-destructive'
  //         }`}>
  //           <Icon 
  //             name={
  //               log.type === 'auth' ? 'LogIn' :
  //               log.type === 'billing' ? 'Receipt' :
  //               log.type === 'profile'? 'User' : 'Shield'
  //             } 
  //             size={16} 
  //           />
  //         </div>
  //         <div className="flex-1">
  //           <div className="flex items-center justify-between">
  //             <h5 className="text-sm font-medium text-foreground">{log.action}</h5>
  //             <span className="text-xs text-muted-foreground">{formatDate(log.timestamp)}</span>
  //           </div>
  //           <p className="text-sm text-muted-foreground mt-1">{log.details}</p>
  //         </div>
  //       </div>
  //     ))}
  //   </div>
  // );

  // const renderPermissions = () => (
  //   <div className="space-y-6">
  //     <div className="bg-muted/30 rounded-lg p-6">
  //       <h4 className="text-sm font-medium text-foreground mb-4">Current Permissions</h4>
  //       <div className="space-y-3">
  //         {Object.entries(employee.permissions || {}).map(([key, value]) => (
  //           <div key={key} className="flex items-center justify-between p-3 bg-card rounded-lg border border-border">
  //             <div>
  //               <span className="text-sm font-medium text-foreground">
  //                 {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
  //               </span>
  //             </div>
  //             <span className={`px-2 py-1 rounded-full text-xs font-medium ${
  //               value ? 'text-success bg-success/10' : 'text-muted-foreground bg-muted'
  //             }`}>
  //               {value ? 'Granted' : 'Denied'}
  //             </span>
  //           </div>
  //         ))}
  //       </div>
  //     </div>
  //   </div>
  // );

  return (
    <div className="fixed inset-0 z-1200 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity bg-black/50" onClick={onClose} />
        
        <div className="inline-block w-full max-w-4xl my-8 overflow-hidden text-left align-middle transition-all transform bg-card shadow-modal rounded-lg border border-border">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-border">
            <div className="flex items-center space-x-4">
              {/* <div className="w-16 h-16 rounded-full overflow-hidden bg-muted flex-shrink-0">
                <Image
                  src={employee.avatar}
                  alt={employee.name}
                  className="w-full h-full object-cover"
                />
              </div> */}
              <div>
                <h3 className="text-xl font-semibold text-foreground">{employee.name}</h3>
                <div className="flex items-center space-x-2 mt-1">
                  {getRoleBadge(employee.role)}
                  {getStatusBadge(employee.status)}
                </div>
                {/* <p className="text-sm text-muted-foreground mt-1">
                  Last login: {formatDate(employee.lastLogin)}
                </p> */}
              </div>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
            >
              <Icon name="X" size={20} />
            </Button>
          </div>

          {/* Tabs */}
          <div className="border-b border-border">
            <nav className="flex space-x-8 px-6">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                    activeTab === tab.id
                      ? 'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                  }`}
                >
                  <div className="flex items-center space-x-2">
                    <Icon name={tab.icon} size={16} />
                    <span>{tab.label}</span>
                  </div>
                </button>
              ))}
            </nav>
          </div>

          {/* Content */}
          <div className="p-6 max-h-96 overflow-y-auto">
            {activeTab === 'overview' && renderOverview()}
            {activeTab === 'billing' && renderBillingHistory()}
            {activeTab === 'activity' && renderActivityLog()}
            {activeTab === 'permissions' && renderPermissions()}
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end space-x-3 p-6 border-t border-border">
            <Button variant="outline" onClick={onClose}>
              Close
            </Button>
            {/* <Button variant="default" iconName="Edit" iconPosition="left" iconSize={16}>
              Edit Employee
            </Button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeProfileModal;